import React, { Component } from 'react'
import LoadingWindow from '../../../components/LoadingWindow';
import { BsFileArrowUpFill, BsFileArrowDownFill, BsArrowCounterclockwise } from "react-icons/bs";
import { AiOutlineReload, AiOutlineBarChart } from "react-icons/ai";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, PointElement, LineElement, Filler } from 'chart.js';
import { Line, getElementAtEvent } from 'react-chartjs-2';
import { AgroupRoutes, GroupLineGraphData, LineGraphData, OptionsLineGraph, ProdLine, ProductLineFormat, Routes } from "./Class";
import "../../../css/dashboard.css"
import { getValueCookie } from '../../../services/cookieService';
import { getInformationWithDataGlobalSales, getInformationWithData } from '../../../services/CABE';
import { NumberFormat, OrderArrayASCDESC, random_rgba, material_cold_rgba } from '../../../functions/generalFunctions';
import { getIndexElement } from '../../../functions/searchInObject';
import { pricesFormat } from '../../../functions/pricesFormat';
import { DateFormatMAS90, formatDateByLine } from '../../../functions/dateFormat';
// Menu
import { Menu } from "../../../components/Menu/Menu";


import axios from "axios";

export default class GeneralMarginPricesV2 extends Component {
    constructor(props) {
        super(props)
        this.chartRef = React.createRef()
        this.ModalLoading = React.createRef();
        this.allRoutes = null;
        this.ByProdLines = []; // Initialize here
        this.prodLineMap = new Map(); // To store and reuse instances
        ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale,
            LinearScale,
            BarElement,
            Title, CategoryScale,
            LinearScale,
            PointElement,
            LineElement,

            Filler,
        );
    }
    state = {
        Routes: [],
        Order:true,
        ProductLines: [],
        FilterProductLines: [],
        CheckRoutes: [],
        CheckProdLines: [],
        AllData: null,
        ItemPerDay: [],
        TitleItemPerDay: {
            ProductLine: '',
            Route: '',
            Date: '',
        },
        ScrollY:null,
        ActiveTab:'MarginsPerRoute',
        datasetVisibility: {},
        totalsWLabels: [],
        VisibleRoutes: [],
        // Variables to save the totals and recalculate the total
        routeTotalSales: [],
        routeTotalCosts: [],
        totalSales: [],
        totalCosts: [],
        RouteTotals: [],
        dateRange: [],
        RoutesArray: [],
    }

    checkFilterRouter(id, Route) {
        const checkbox = document.getElementById(id);

        if (Route === 'All' && checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP1')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
            }
        } else if (Route === 'All' && !checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP1')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;
            }
        } else {
            let cond = true
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP1')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckGMP1All')) {
                    cond = false
                    break
                }
            }
            let all = document.getElementById('CheckGMP1All')
            if (all) {
                all.checked = cond
            }


        }

    }
    checkFilterRouterP2(id, Route) {
        const checkbox = document.getElementById(id);

        if (Route === 'All' && checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
            }
        } else if (Route === 'All' && !checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;
            }
        } else {
            let cond = true
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP2')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckGMP2All')) {
                    cond = false
                    break
                }
            }
            let all = document.getElementById('CheckGMP2All')
            if (all) {
                all.checked = cond
            }


        }
        this.FilterBySelectedRouteAndProdLine()
    }

    onClick = (e, reference, Title) => {
        let Label = reference.current.data.datasets[0].label
        let Position = getElementAtEvent(reference.current, e)
        if (Position.length > 0) {
            let PosIndex = Position[0].index
            const index = getIndexElement(this.state.ProductLines, 'Title', Label)
            if (index !== -1) {
                const Title = this.state.TitleItemPerDay
                let temporal = formatDateByLine(this.state.ProductLines[index].DataLine.labels[PosIndex])
                let info = this.state.AllData[this.state.ProductLines[index].Route]["detail"][temporal]["detail"][this.state.ProductLines[index].ProdLine].detail
                for (const Line of info) {
                    Line.Margin=pricesFormat((Line.ExtensionAmt - Line.TotalCost) / (Line.ExtensionAmt) * 100)
                }
                Title.Route = this.state.ProductLines[index].Route
                Title.ProductLine = this.state.ProductLines[index].ProdLine
                Title.Date = DateFormatMAS90(temporal)
                this.setState({ ItemPerDay: info, TitleItemPerDay: Title })
                let button = document.getElementById('GMPerItem')
                if (button) {
                    button.click()
                }
            }
        }

    }

    specificDetailByRoute = (e, reference, Title) => {
        if (Title !== "Total") {
            let Position = getElementAtEvent(reference.current, e)
            if (Position.length > 0) {
                let indexDataSet = Position[0].datasetIndex
                let PosIndex = Position[0].index
                let Label = reference.current.data.datasets[indexDataSet].label
                const index = getIndexElement(this.state.Routes, 'Route', Title)
                if (index !== -1) {
                    const Title = this.state.TitleItemPerDay
                    let temporal = formatDateByLine(this.state.Routes[index].DataLine.labels[PosIndex])
                    let specificDate = this.state.AllData[Label]["detail"][temporal]["detail"]
                    let info = []
                    for (const ProductLine of Object.keys(specificDate)) {
                        info = info.concat(specificDate[ProductLine].detail)
                    }
                    for (const Line of info) {
                        Line.Margin=pricesFormat(((Line.ExtensionAmt - Line.TotalCost) / (Line.ExtensionAmt)) * 100)
                    }
                    Title.Route = Label
                    Title.ProductLine = ''
                    Title.Date = DateFormatMAS90(temporal)
                    this.setState({ ItemPerDay: info, TitleItemPerDay: Title })
                    let button = document.getElementById('GMPerItem')
                    if (button) {
                        this.ActiveTab("MarginsPerItem")
                        button.click()
                    }
                }
            }
        }


    }


    checkFilterProdLineP2(id, Route) {
        const checkbox = document.getElementById(id);

        if (Route === 'All' && checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMProdLineP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
            }
        } else if (Route === 'All' && !checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMProdLineP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;
            }
        } else {
            let cond = true
            const checkboxList = document.getElementsByClassName('ReportGMProdLineP2')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckGMProdLineP2')) {
                    cond = false
                    break
                }
            }
            let all = document.getElementById('CheckGMProdLineP2')
            if (all) {
                all.checked = cond
            }


        }
        this.FilterBySelectedRouteAndProdLine()
    }

    OrderInformation(key){
        let order=this.state.Order?'asc':'desc'
        let temporal=OrderArrayASCDESC(this.state.ItemPerDay,key,order)
        this.setState({ItemPerDay:temporal,Order:!this.state.Order})
    }

    async getMargins(start,end) {
        const url = 'https://backv2.portalmanager.pro';
        // const url = 'http://localhost:4800';

        let responseBack;
        const payload = {
            data: {
                start,
                end
            }
        };
        const prefix = getValueCookie('apiPrefix');
        let query = prefix + "/invoices/margin-report-v2";
        // let query = "/Invoices/margin-report";

        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data;
            }
        ).catch(error => {
            console.log(error)
        })
        return responseBack
    }

    async getInformation() {
        let Start = document.getElementById('ReportGMStartDate').value
        let End = document.getElementById('ReportGMEndDate').value

        if (!Start || !End) {
            alert('Please select both a start date and an end date before loading data.');
            return;
        }

        // Clean Route totals
        this.setState({RouteTotals: []})

        this.ModalLoading.current.showState(true);
        // const result = await getInformationWithDataGlobalSales('/Invoice/report/InvoiceMarginByRoute', data)
        const result = await this.getMargins(Start,End)
        let CheckData = []
        let CheckRoutes = [{ name: 'All' }]
        let CheckProdLines = [{ name: 'All' }]
        let routeTotalSales = []
        let routeTotalCosts = []
        let totalSales = []
        let totalCosts = []

        this.getDateRange(Start, End)
        
        if (result) {
            let RoutesArray = Object.keys(result)
            this.setState({RoutesArray})
            // let allRoutes = new Routes("All Margins", new OptionsLineGraph("All Margins"), new GroupLineGraphData())
            if (!this.allRoutes) {
                this.allRoutes = new Routes("All Margins", new OptionsLineGraph("All Margins"), new GroupLineGraphData());
            }
            let AgroupData=[]
            RoutesArray.forEach((Route, index) => {
                if (Route !== "Total") {
                    // Save the Routes (Pallet, Warehouse, etc.)
                    CheckRoutes.push({ name: Route })
                    // initialize array of showing Routes
                    this.setState(prevState => ({
                        VisibleRoutes: [...prevState.VisibleRoutes, 1]
                    }))

                    let labels = Object.keys(result[Route]["detail"])

                    let data = []
                    let ProdLines = []

                    for (const Label of labels) {
                        // // Get the total of each Route
                        const routeData = result[Route]["detail"][Label]
                        data.push(Number(routeData["PromMarkup"]).toFixed(2))
                        // // Get total Sales and cost of each Route
                        // routeTotalSales.push(routeData["ExtensionAmt"]["total"].toFixed(2))
                        // routeTotalCosts.push(routeData["TotalCost"]["total"].toFixed(2))
                        
                        // Set the totals to a state variable
                        this.generateTotalsState(routeData, Label, Route)

                        let productLines = Object.keys(result[Route]["detail"][Label]["detail"])
                        for (const ProductLine of productLines) {
                            // Get the Product line per Date per Route
                            const index = getIndexElement(ProdLines, 'ProdLine', ProductLine)
                            const index2 = getIndexElement(CheckProdLines, 'name', ProductLine)

                            if (index2 === -1) {
                                CheckProdLines.push({ name: ProductLine })
                            }

                            if (index === -1) {
                                let newP = new ProductLineFormat(ProductLine, Route)
                                newP.Dates.push(DateFormatMAS90(Label))
                                newP.Values.push(Number(result[Route]["detail"][Label]["detail"][ProductLine]["PromMarkup"]).toFixed(2))
                                ProdLines.push(newP)
                            } else {
                                ProdLines[index].Dates.push(DateFormatMAS90(Label))
                                ProdLines[index].Values.push(Number(result[Route]["detail"][Label]["detail"][ProductLine]["PromMarkup"]).toFixed(2))
                            }
                        }
                    }
                    let currentByProdLines = []; // Temporary array for this iteration

                    ProdLines.forEach((Prod, index) => {
                        const key = `${Route}-${Prod.ProdLine}`; // Unique key
                        
                        // Check if we already have this ProdLine instance
                        if (!this.prodLineMap.has(key)) {
                            // Create new instance only if it doesn't exist
                            const newProdLine = new ProdLine(
                                Route, 
                                Prod.ProdLine, 
                                new OptionsLineGraph(Route + '-' + Prod.ProdLine), 
                                new LineGraphData(Prod.Dates, Route + '-' + Prod.ProdLine, Prod.Values, material_cold_rgba(index))
                            );
                            this.prodLineMap.set(key, newProdLine);
                        } else {
                            // Update existing instance with new data
                            const existingProdLine = this.prodLineMap.get(key);
                            // Update the data (you might need to add an update method to ProdLine)
                            existingProdLine.DataLine = new LineGraphData(Prod.Dates, Route + '-' + Prod.ProdLine, Prod.Values, material_cold_rgba(index));
                        }
                        
                        currentByProdLines.push(this.prodLineMap.get(key));
                    });

                    // Update the class property
                    this.ByProdLines.push(...currentByProdLines);

                    let colorRoute = material_cold_rgba(index)

                    let newDate = []
                    for (const date of labels) {
                        newDate.push(DateFormatMAS90(date))
                    }
                    this.allRoutes.DataLine.addLabels(newDate)
                    AgroupData.push(new AgroupRoutes(Route, data, colorRoute, newDate))
           } else {
                    let labels = Object.keys(result[Route])
                    let data = []
                    for (const Label of labels) {
                        data.push(Number(result[Route][Label]["PromMarkup"]).toFixed(2))
                        totalSales.push(result[Route][Label]["ExtensionAmt"]["total"].toFixed(2))
                        totalCosts.push(result[Route][Label]["TotalCost"]["total"].toFixed(2))
                    }
                    let newDate = []
                    for (const date of labels) {
                        newDate.push(DateFormatMAS90(date))
                    }
                    CheckData.unshift(new Routes(Route, new OptionsLineGraph(Route), new LineGraphData(newDate, Route, data, material_cold_rgba(index))))
                }
                
            })
            for (const Data of AgroupData) {
                this.allRoutes.DataLine.addNewDataSet(Data.Route,Data.Data,Data.Color,Data.Dates)
            }
            CheckData.push(this.allRoutes)
        }

        if (CheckData.length === 0 || !CheckData[0]) {
            this.ModalLoading.current.showState(false);
            alert('No data found for the selected date range. Please try different dates.');
            return;
        }

        const dates = CheckData[0].DataLine.labels.length
        routeTotalSales = this.chunkArray(routeTotalSales,dates)
        routeTotalCosts = this.chunkArray(routeTotalCosts,dates)
        this.setState({ Routes: CheckData, ProductLines: this.ByProdLines, FilterProductLines: this.ByProdLines, CheckRoutes: CheckRoutes, CheckProdLines: CheckProdLines, AllData: result, routeTotalSales, routeTotalCosts, totalSales, totalCosts})
        this.ModalLoading.current.showState(false);

        console.log("totalSales", this.state.totalSales)
        console.log("totalCost", this.state.totalCosts)
        console.log("RouteTotals", this.state.RouteTotals)

        // Operation for update totals
        
        const updateTotals = routeTotalSales
    }

    // Generate array of days
    getDateRange(start, end) {
    const dateArray = [];
    let current = new Date(start + "T00:00:00"); // force set hour
    const endDt = new Date(end + "T00:00:00");

    while (current <= endDt) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, '0');
        const day = String(current.getDate()).padStart(2, '0');
        dateArray.push(`${year}-${month}-${day}`);

        // go on to the next date without exclude the end date
        current.setUTCDate(current.getUTCDate() + 1);
    }

    this.setState({dateRange: dateArray})
    }

    // Store the totals by date
    generateTotalsState(data, date, name) {
        const totalRoute = Number(data["PromMarkup"]).toFixed(2)
        const salesTotal = Number(data["ExtensionAmt"]["total"]).toFixed(2)
        const costTotal = Number(data["TotalCost"]["total"]).toFixed(2)
        let routeData = {
            name,
            totalRoute,
            salesTotal,
            costTotal,
            date
        }

        this.setState((prevState) => ({
            RouteTotals: [
                ...prevState.RouteTotals,
                routeData
            ]
        }))
    }

    // Remove route from the total
    removeRoute(routeIndex, prevTotals){
        let {dateRange, RouteTotals, totalCosts, totalSales, RoutesArray} = this.state
        let newTotalSales = []
        let newTotalCosts = []

        let routeFiltered = RouteTotals.filter(item => item.name === RoutesArray[routeIndex])

        const newTotals = dateRange.map((date, i) => {
            // Find if this date exists in routeFiltered
            const route = routeFiltered.find(r => r.date === date);
            
            if (route) {
                // Date found - calculate new total
                const calculateNewTotal = 
                    ((totalSales[i] - route.salesTotal) - (totalCosts[i] - route.costTotal)) / 
                    (totalSales[i] - route.salesTotal) * 100;
                newTotalSales.push(totalSales[i] - route.salesTotal)
                newTotalCosts.push(totalCosts[i] - route.costTotal)
                return calculateNewTotal;
            } else {
                newTotalSales.push(totalSales[i])
                newTotalCosts.push(totalCosts[i])
                // Date not found - use previous total
                return prevTotals[i];
            }
        });
        console.log("remove - newTotalSales", newTotalSales)
        console.log("remove - newTotalCosts", newTotalCosts)
        this.setState({totalSales: newTotalSales, totalCosts: newTotalCosts})
        return newTotals
        // const newTotal = ((totalSales - routeTotalSales) - (totalCost - routeTotalCost)) / (totalSales - routeTotalSales) * 100;
    }


     BackToP(id) {
        let button = document.getElementById(id)
        this.setState({ActiveTab:"MarginsPerProductLine"})
        if (button) {
             button.click()
            setTimeout(() => {  
                this.Scroll()
              }, 1000);
        }
        
       
    }

    FilterBySelectedRouteAndProdLine(){
        const checkRoute = document.getElementsByClassName('ReportGMRoutesP2')
        const checkLines = document.getElementsByClassName('ReportGMProdLineP2')
        let Items=[]
        for (const Route of checkRoute) {
            for (const ProdLine of checkLines) {
                if(Route.checked&&ProdLine.checked)
                    Items.push(Route.name+'-'+ProdLine.name)
            }
        }
        let SelectGraphs=[]
        for (const Graph of Items) {
            const index=getIndexElement(this.state.ProductLines,'Title',Graph)
            if(index!==-1){
                SelectGraphs.push(this.state.ProductLines[index])
            }
            
        }

        this.setState({FilterProductLines:SelectGraphs})

    }

    componentDidMount() {
        window.addEventListener('scroll', this.setScrollPosition);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.setScrollPosition);
    }

    setScrollPosition=()=>{
        if(this.state.ActiveTab==="MarginsPerProductLine"){
        let posY=window.scrollY
        this.setState({ScrollY:posY})
        }
    }
    ActiveTab(name){
        this.setState({ActiveTab:name})
        if(name==="MarginsPerProductLine"){
            setTimeout(() => {  
                this.Scroll()
              }, 1000);
        }
    }
    Scroll(){
        window.focus()
        window.scrollTo(0, this.state.ScrollY);
    }

    handleLegendClick = (datasetIndex, currentChart) => {
        // DON'T toggle currentChart here - it's already been toggled in onClick!
        // Just check its current state and sync to other charts
        
        const isNowVisible = currentChart.isDatasetVisible(datasetIndex);
        
        // 0. Update the data in state
        this.updateTotalsGraph(datasetIndex, isNowVisible);

        // 1. Get the route and visible status
        this.setState(prevState => ({
            VisibleRoutes: prevState.VisibleRoutes.map((value, index) => {
                if(index === datasetIndex){
                    return isNowVisible ? 1 : 0
                }
                return value
            })
        }))
        
        // 2. Tell Chart.js to refresh and read the new data
        setTimeout(() => {
            this.state.Routes.forEach(route => {
                const chart = route.Reference.current;
                if (chart && chart !== currentChart) {
                    // Match the visibility
                    // if (isNowVisible) {
                    //     chart.show(datasetIndex);
                    // } else {
                    //     chart.hide(datasetIndex);
                    // }
                    // Force chart to re-render with new data
                    chart.update();
                }
            });
        }, 0);

        // Update state for tracking
        this.setState(prevState => ({
            datasetVisibility: {
                ...prevState.datasetVisibility,
                [datasetIndex]: isNowVisible
            }
        }));
    }

    updateTotalsGraph = (routeIndex,isVisible) => {
        // Get the routes
        const routes = this.state.Routes[1].DataLine
        const total = this.state.Routes[0].DataLine
        const routeNames = routes.datasets
        const dates = total.labels.length
        let newTotals = []

        // Calculate the new total without the route
        
        let routeAverages = routes.datasets[routeIndex].data
        let totalAverages = total.datasets[0].data
        const totalRoutes = routeNames.length
        
        
        if(isVisible){
            // Convert from String to Int
            routeAverages = routeAverages.map(Number)
            totalAverages = totalAverages.map(Number)
            // Get only the active routes
            const visibleRoutes = this.countOccurrences(this.state.VisibleRoutes, 1)
            
            
            
            // Remove route from the total
            for (let i = 0; i < dates; i++){
                const newTotal  = ((totalAverages[i] * visibleRoutes + routeAverages[i]) / (visibleRoutes + 1)).toFixed(2)
                newTotals[i] = newTotal
            }
            
        } else {
            const visibleRoutes = this.countOccurrences(this.state.VisibleRoutes, 1)
            
            // Convert from String to Int
            routeAverages = routeAverages.map(Number)
            totalAverages = totalAverages.map(Number)
            // console.log("isVisible routeAverages:", routeAverages)
            // console.log("route data", routes.datasets[routeIndex].data)
            console.log("totals data", total)
            // Remove route from the total

            newTotals = this.removeRoute(routeIndex,totalAverages)

            // for (let i = 0; i < dates; i++){
            //     console.log("totalAverages[i]",totalAverages[i])
            //     console.log("visibleRoutes",visibleRoutes)
            //     console.log("routeAverages[i]",routeAverages[i])
            //     let newTotal = 0
            //     if(visibleRoutes > 1){
            //         newTotal  = ((totalAverages[i] * visibleRoutes - routeAverages[i]) / (visibleRoutes -1)).toFixed(2)
            //         console.log("newTotal", newTotal)
            //         }
            //         newTotals[i] = newTotal
            //     }
        }

        const updatedRoutes = this.state.Routes.map((route, index) => {
            if (index === 0) {
                // Update the totals route
                return {
                    ...route,
                    DataLine: {
                        ...route.DataLine,
                        datasets: route.DataLine.datasets.map((dataset, dsIndex) => {
                            if (dsIndex === 0) {
                                return {
                                    ...dataset,
                                    data: newTotals.map(String)
                                };
                            }
                            return dataset;
                        })
                    }
                };
            }
            return route;
        });
        console.log("updatedRoutes", updatedRoutes)
        this.setState({ Routes: updatedRoutes });

    }

    countOccurrences = (arr, val) => {
        return arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
    }

    // Divide in groups of the date range
    chunkArray(arr, chunkSize = 4) {
        const result = []
        for(let i = 0; i < arr.length; i+= chunkSize){
            result.push(arr.slice(i,i + chunkSize));
        }
        return result
    }

    // Simple function to reasign null or undefined values
    checkTotalValue(labels, dates) {
        let datesData = []
        for (const Date of dates) {

        }
    }

    render() {
        const SortIcon = () => (
            <span style={{ display: 'flex', flexDirection: 'column', opacity: 0.5, lineHeight: 0.8, marginLeft: '4px' }}>
                <BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} />
            </span>
        );

        return (
            <div className="dash-page container-fluid pb-5" style={{ paddingTop: '70px' }}>
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div className="container-fluid" style={{ paddingTop: '1.5rem' }}>

                    {/* ── Hero ── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                        borderRadius: '16px',
                        padding: '2rem 2.5rem',
                        marginBottom: '2rem',
                        marginTop: '2rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '1rem',
                    }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                                <AiOutlineBarChart style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                                <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                    General Margin Report
                                </h2>
                            </div>
                            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                                Margin analysis by route and product line · {getValueCookie('Company')}
                            </p>
                        </div>
                        <div style={{
                            background: 'rgba(255,255,255,0.1)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '10px',
                            padding: '0.5rem 1.25rem',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                        }}>
                            Margins
                        </div>
                    </div>

                    {/* ── Action bar: date range + load ── */}
                    <div className="row g-3 mb-4 align-items-end">
                        <div className="col-sm-12 col-md-4">
                            <label style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#334155', marginBottom: '0.4rem', display: 'block' }}>
                                Start Date
                            </label>
                            <input
                                className="form-control"
                                id="ReportGMStartDate"
                                type="date"
                                style={{ padding: '0.75rem 1rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9375rem' }}
                            />
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <label style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#334155', marginBottom: '0.4rem', display: 'block' }}>
                                End Date
                            </label>
                            <input
                                className="form-control"
                                id="ReportGMEndDate"
                                type="date"
                                style={{ padding: '0.75rem 1rem', border: '1.5px solid #E2E8F0', borderRadius: '10px', fontSize: '0.9375rem' }}
                            />
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <button
                                onClick={() => this.getInformation()}
                                type="button"
                                style={{
                                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                    border: 'none',
                                    borderRadius: '10px',
                                    color: 'white',
                                    padding: '0.75rem 1.5rem',
                                    fontWeight: 600,
                                    fontSize: '0.9375rem',
                                    cursor: 'pointer',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.15)',
                                }}
                            >
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>
                    </div>

                    {/* ── Tabs (visible only when data is loaded) ── */}
                    <div hidden={this.state.AllData === null}>

                        {/* Tab nav */}
                        <ul className="nav nav-tabs mb-0" id="ScanningControls" role="tablist" style={{ borderBottom: '2px solid #E2E8F0' }}>
                            <li className="nav-item" role="presentation">
                                <button onClick={() => this.ActiveTab("MarginsPerRoute")} id="GMPerRoute" className="nav-link active" data-bs-toggle="tab" data-bs-target="#ReportGMPerRoute" type="button" role="tab" style={{ fontWeight: 600, fontSize: '0.875rem' }}>
                                    Margins Per Route
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button onClick={() => this.ActiveTab("MarginsPerProductLine")} id="GMPerProductLine" className="nav-link" data-bs-toggle="tab" data-bs-target="#ReportGMPerProductLine" type="button" role="tab" style={{ fontWeight: 600, fontSize: '0.875rem' }}>
                                    Margins Per Product Line
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button onClick={() => this.ActiveTab("MarginsPerItem")} hidden id="GMPerItem" className="nav-link" data-bs-toggle="tab" data-bs-target="#ReportGMPerItem" type="button" role="tab" style={{ fontWeight: 600, fontSize: '0.875rem' }}>
                                    Margins Per Item
                                </button>
                            </li>
                        </ul>

                        <div className="tab-content pt-4" id="allScanningTab" style={{ overflowX: 'auto' }}>

                            {/* ── Tab 1: Margins Per Route ── */}
                            <div className="tab-pane fade show active" id="ReportGMPerRoute" role="tabpanel">
                                <div className="row g-4">
                                    {this.state.Routes.map((Route, R) => {
                                        const modifiedOptions = {
                                            ...Route.OptionsLineGraph,
                                            plugins: {
                                                ...Route.OptionsLineGraph.plugins,
                                                legend: {
                                                    ...Route.OptionsLineGraph.plugins.legend,
                                                    onClick: (event, legendItem, legend) => {
                                                        const index = legendItem.datasetIndex;
                                                        const ci = legend.chart;
                                                        ci.setDatasetVisibility(index, !ci.isDatasetVisible(index));
                                                        ci.update();
                                                        this.handleLegendClick(index, ci);
                                                    }
                                                }
                                            }
                                        };
                                        return (
                                            <div className="col-sm-12 col-md-6" key={Route.Route + '-' + Route.ProdLine}>
                                                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                                                    <div className="card-body">
                                                        <Line
                                                            onClick={(e) => this.specificDetailByRoute(e, Route.Reference, Route.Route)}
                                                            ref={Route.Reference}
                                                            options={modifiedOptions}
                                                            data={Route.DataLine}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* ── Tab 2: Margins Per Product Line ── */}
                            <div className="tab-pane fade" id="ReportGMPerProductLine" role="tabpanel">
                                <div className="row g-4">

                                    {/* Filters sidebar */}
                                    <div className="col-sm-12 col-md-2">
                                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                            {/* Mini header */}
                                            <div style={{
                                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                                padding: '0.875rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                            }}>
                                                <AiOutlineBarChart style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1rem' }} />
                                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem', letterSpacing: '0.03em' }}>Filters</span>
                                            </div>

                                            <div className="card-body" style={{ padding: '1rem' }}>
                                                {/* Routes section */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.625rem' }}>
                                                    <div style={{ width: '3px', height: '14px', background: '#2563EB', borderRadius: '2px' }} />
                                                    <span style={{ fontSize: '0.7rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1e40af' }}>Routes</span>
                                                    <span style={{ background: 'rgba(37,99,235,0.1)', color: '#1e40af', borderRadius: '999px', padding: '0px 6px', fontSize: '0.7rem', fontWeight: 700 }}>
                                                        {this.state.CheckRoutes.length}
                                                    </span>
                                                </div>
                                                {this.state.CheckRoutes.map((element, e) => (
                                                    <label
                                                        key={"P2" + e}
                                                        htmlFor={'CheckGMP2' + element.name}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '0.5rem',
                                                            padding: '0.3rem 0.4rem',
                                                            borderRadius: '6px',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8375rem',
                                                            color: '#334155',
                                                            marginBottom: '2px',
                                                            transition: 'background 0.15s',
                                                        }}
                                                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,99,235,0.06)'}
                                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                                    >
                                                        <input
                                                            className="form-check-input ReportGMRoutesP2"
                                                            type="checkbox"
                                                            name={element.name}
                                                            onChange={() => this.checkFilterRouterP2('CheckGMP2' + element.name, element.name)}
                                                            defaultChecked
                                                            id={'CheckGMP2' + element.name}
                                                            style={{ margin: 0, flexShrink: 0 }}
                                                        />
                                                        {element.name}
                                                    </label>
                                                ))}

                                                {/* Divider */}
                                                <div style={{ borderTop: '1px solid #E2E8F0', margin: '0.875rem 0' }} />

                                                {/* Product Lines section */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.625rem' }}>
                                                    <div style={{ width: '3px', height: '14px', background: '#8b5cf6', borderRadius: '2px' }} />
                                                    <span style={{ fontSize: '0.7rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#5b21b6' }}>Product Lines</span>
                                                    <span style={{ background: 'rgba(139,92,246,0.1)', color: '#5b21b6', borderRadius: '999px', padding: '0px 6px', fontSize: '0.7rem', fontWeight: 700 }}>
                                                        {this.state.CheckProdLines.length}
                                                    </span>
                                                </div>
                                                {this.state.CheckProdLines.map((element, e) => (
                                                    <label
                                                        key={"RoutesP2" + e}
                                                        htmlFor={'CheckGMProdLineP2' + element.name}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '0.5rem',
                                                            padding: '0.3rem 0.4rem',
                                                            borderRadius: '6px',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8375rem',
                                                            color: '#334155',
                                                            marginBottom: '2px',
                                                            transition: 'background 0.15s',
                                                        }}
                                                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(139,92,246,0.06)'}
                                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                                    >
                                                        <input
                                                            className="form-check-input ReportGMProdLineP2"
                                                            type="checkbox"
                                                            name={element.name}
                                                            onChange={() => this.checkFilterProdLineP2('CheckGMProdLineP2' + element.name, element.name)}
                                                            defaultChecked
                                                            id={'CheckGMProdLineP2' + element.name}
                                                            style={{ margin: 0, flexShrink: 0 }}
                                                        />
                                                        {element.name}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Charts grid */}
                                    <div className="col-sm-12 col-md-10">
                                        <div className="row g-3">
                                            {this.state.FilterProductLines.map((ProductLine, R) => (
                                                <div className="col-sm-12 col-md-6" key={ProductLine.Route + '-' + ProductLine.ProdLine}>
                                                    <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                                                        <div className="card-body">
                                                            <h6 className="card-title-clean mb-3" style={{ fontSize: '0.8125rem', color: '#334155' }}>
                                                                {ProductLine.ProdLine}
                                                            </h6>
                                                            <Line
                                                                ref={ProductLine.Reference}
                                                                onClick={(e) => this.onClick(e, ProductLine.Reference)}
                                                                options={ProductLine.OptionsLineGraph}
                                                                data={ProductLine.DataLine}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Tab 3: Margins Per Item ── */}
                            <div className="tab-pane fade" id="ReportGMPerItem" role="tabpanel">

                                {/* Context bar */}
                                <div className="mb-4">
                                    <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                        {/* Gradient strip */}
                                        <div style={{
                                            background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                            padding: '0.75rem 1.25rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            flexWrap: 'wrap',
                                            gap: '0.75rem',
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => this.BackToP(this.state.TitleItemPerDay.ProductLine === '' ? 'GMPerRoute' : 'GMPerProductLine')}
                                                    style={{
                                                        background: 'rgba(255,255,255,0.12)',
                                                        border: '1px solid rgba(255,255,255,0.25)',
                                                        borderRadius: '8px',
                                                        color: 'white',
                                                        padding: '0.375rem 0.875rem',
                                                        fontWeight: 600,
                                                        fontSize: '0.8125rem',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.4rem',
                                                    }}
                                                >
                                                    <BsArrowCounterclockwise /> Return
                                                </button>
                                                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem' }}>Margin detail view</span>
                                            </div>
                                            {/* Context badges — white on dark */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                                <span style={{ background: 'rgba(255,255,255,0.12)', color: 'white', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', padding: '3px 10px', fontSize: '0.78rem', fontWeight: 600 }}>
                                                    Route · {this.state.TitleItemPerDay.Route}
                                                </span>
                                                <span style={{ background: 'rgba(255,255,255,0.12)', color: 'white', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', padding: '3px 10px', fontSize: '0.78rem', fontWeight: 600 }}>
                                                    Date · {this.state.TitleItemPerDay.Date}
                                                </span>
                                                {this.state.TitleItemPerDay.ProductLine !== '' && (
                                                    <span style={{ background: 'rgba(139,92,246,0.35)', color: '#e9d5ff', border: '1px solid rgba(167,139,250,0.5)', borderRadius: '8px', padding: '3px 10px', fontSize: '0.78rem', fontWeight: 600 }}>
                                                        {this.state.TitleItemPerDay.ProductLine}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        {/* Stats strip */}
                                        <div style={{ background: '#F8FAFC', padding: '0.5rem 1.25rem', borderBottom: '1px solid #E2E8F0', display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
                                            <span style={{ fontSize: '0.78rem', color: '#64748B' }}>
                                                <strong style={{ color: '#0F172A' }}>{this.state.ItemPerDay.length}</strong> line items
                                            </span>
                                            <span style={{ fontSize: '0.78rem', color: '#64748B' }}>
                                                Avg margin: <strong style={{ color: this.state.ItemPerDay.length > 0 && (this.state.ItemPerDay.reduce((s, i) => s + (Number(i.Margin) || 0), 0) / this.state.ItemPerDay.length) >= 20 ? '#059669' : '#D97706' }}>
                                                    {this.state.ItemPerDay.length > 0 ? (this.state.ItemPerDay.reduce((s, i) => s + (Number(i.Margin) || 0), 0) / this.state.ItemPerDay.length).toFixed(2) : '0.00'}%
                                                </strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Detail table */}
                                <div className="tableFixHeadSmall" style={{ maxHeight: '65vh' }}>
                                    <table className="table table-clean align-middle">
                                        <thead>
                                            <tr>
                                                <th onClick={() => this.OrderInformation('InvoiceNo')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>Invoice No <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('CustomerNo')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>Customer No <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('SalespersonNo')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>Sales Person <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('BillToName')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>Customer Name <SortIcon /></span>
                                                </th>
                                                {this.state.TitleItemPerDay.ProductLine === '' && (
                                                    <th onClick={() => this.OrderInformation('ProductLineDesc')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                        <span style={{ display: 'flex', alignItems: 'center' }}>Product Line <SortIcon /></span>
                                                    </th>
                                                )}
                                                <th onClick={() => this.OrderInformation('ItemCode')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>Item Code <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('ItemCodeDesc')} style={{ cursor: 'pointer' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>Description <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('QuantityShipped')} className="text-center" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Qty Shipped <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('UnitPrice')} className="text-end" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>Unit Price <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('UnitCost')} className="text-end" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>Unit Cost <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('ExtensionAmt')} className="text-end" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>Ext. Amt <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('TotalCost')} className="text-end" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>Total Cost <SortIcon /></span>
                                                </th>
                                                <th onClick={() => this.OrderInformation('Margin')} className="text-center" style={{ cursor: 'pointer' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Margin <SortIcon /></span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.ItemPerDay.map((item, i) => {
                                                const margin = Number(item.Margin) || 0;
                                                const marginColor = margin >= 20 ? '#10b981' : margin >= 10 ? '#F59E0B' : '#EF4444';
                                                const marginBg   = margin >= 20 ? 'rgba(16,185,129,0.08)' : margin >= 10 ? 'rgba(245,158,11,0.08)' : 'rgba(239,68,68,0.08)';
                                                const marginText = margin >= 20 ? '#059669' : margin >= 10 ? '#D97706' : '#DC2626';
                                                return (
                                                    <tr key={i}>
                                                        <td className="text-start" style={{ borderLeft: `3px solid ${marginColor}`, fontWeight: 600, color: '#334155' }}>{item.InvoiceNo}</td>
                                                        <td className="text-center" style={{ color: '#64748B', fontSize: '0.8375rem' }}>{item.CustomerNo}</td>
                                                        <td className="text-center">
                                                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                                {item.SalespersonNo}
                                                            </span>
                                                        </td>
                                                        <td className="text-start" style={{ fontWeight: 500 }}>{item.BillToName}</td>
                                                        {this.state.TitleItemPerDay.ProductLine === '' && (
                                                            <td className="text-start" style={{ color: '#64748B', fontSize: '0.8375rem' }}>{item.ProductLineDesc}</td>
                                                        )}
                                                        <td className="text-start">
                                                            <span style={{ background: 'rgba(37,99,235,0.07)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
                                                                {item.ItemCode}
                                                            </span>
                                                        </td>
                                                        <td className="text-start" style={{ maxWidth: '220px' }}>{item.ItemCodeDesc}</td>
                                                        <td className="text-center" style={{ fontWeight: 600, color: '#334155' }}>{pricesFormat(item.QuantityShipped)}</td>
                                                        <td className="text-end" style={{ color: '#334155' }}>${NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                        <td className="text-end" style={{ color: '#64748B' }}>${NumberFormat(pricesFormat(item.UnitCost))}</td>
                                                        <td className="text-end" style={{ fontWeight: 600, color: '#334155' }}>${NumberFormat(pricesFormat(item.ExtensionAmt))}</td>
                                                        <td className="text-end" style={{ color: '#64748B' }}>${NumberFormat(pricesFormat(item.TotalCost))}</td>
                                                        <td className="text-center">
                                                            <span style={{
                                                                display: 'inline-block',
                                                                padding: '3px 10px',
                                                                borderRadius: '999px',
                                                                fontSize: '0.8rem',
                                                                fontWeight: 700,
                                                                background: marginBg,
                                                                color: marginText,
                                                                border: `1px solid ${marginColor}30`,
                                                                minWidth: '56px',
                                                                textAlign: 'center',
                                                            }}>
                                                                {item.Margin}%
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Empty state */}
                    {this.state.AllData === null && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineBarChart style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>
                                Select a date range and click <strong style={{ color: '#1e3a8a' }}>Load Data</strong> to fetch margins.
                            </p>
                        </div>
                    )}

                </div>
            </div>
        );
    }
}
